<script setup lang="ts">
import FooterBar from '@/components/footer-bar/FooterBar.vue'
import { ref } from 'vue'
import Refine from './components/Refine.vue'
import Engrave from './components/Engrave.vue'
import Disassemble from './components/Disassemble.vue'
import Purify from './components/Purify.vue'

const curTab = ref('refine')
</script>

<template>
  <div class="smithy-page page">
    <h2>暗金工坊</h2>

    <el-tabs v-model="curTab" stretch>
      <el-tab-pane label="精造" name="refine" class="pane" lazy>
        <Refine class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="刻印" name="engrave" class="pane" lazy>
        <Engrave class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="提纯" name="purify" class="pane" lazy>
        <Purify class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="分解" name="disassemble" class="pane" lazy>
        <Disassemble class="pane-item" />
      </el-tab-pane>
    </el-tabs>
    <FooterBar />
  </div>
</template>

<style lang="scss" scoped>
.smithy-page {
  padding-top: 0;
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
  overflow: hidden;
  .el-tabs {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-flow: column nowrap;
    :deep() {
      .el-tabs__content {
        flex: 1;
        .pane {
          height: 100%;
          .pane-item {
            height: 100%;
            overflow: hidden;
            display: flex;
            flex-flow: column nowrap;
          }
        }
      }
    }
  }
}
</style>
